import CheckRounded from "@material-ui/icons/CheckRounded";
import React from "react";
import { ListLabel } from "./modules/ListLabel/ListLabel";

export const ListItem = ({ label, checked }) => {
  return (
    <div className="tw-flex tw-items-center">
      {checked ? (
        <div className="tw-bg-[#479d1e] tw-text-white tw-h-[20px] tw-w-[20px] tw-grid tw-place-content-center tw-rounded-[3px] tw-mr-[13px]">
          <CheckRounded className="!tw-text-[16px]" />
        </div>
      ) : null}

      <ListLabel label={label} />
    </div>
  );
};
